import * as React from 'react';

import AccessibleSVG from '../accessible-svg';

import { Icon } from '../iconTypes';

const IconForward = ({ className = '', color = '#000000', height = 24, title, width = 24 }: Icon) => (
    <AccessibleSVG
        className={`icon-forward ${className}`}
        height={height}
        title={title}
        viewBox="0 0 16 16"
        width={width}
    >
        <path
            d="M7 14c-3.865993 0-7-3.134007-7-7s3.134007-7 7-7 7 3.134007 7 7-3.134007 7-7 7zM5.157023 9.352557l1.17851 1.17851L9.87107 6.995535 6.335534 3.46l-1.17851 1.17851 2.35702 2.357024-2.35702 2.357023z"
            fill={color}
            fillRule="evenodd"
        />
    </AccessibleSVG>
);

export default IconForward;
